const MINUTE = 60;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;
const WEEK = 7 * DAY;
const MONTH = 30 * DAY;
const YEAR = 365 * DAY;

export function relativeTime(isoDate: string | null | undefined, now: Date = new Date()): string {
	if (!isoDate) return '—';
	const then = new Date(isoDate);
	if (isNaN(then.getTime())) return '—';

	const diffSeconds = Math.floor((now.getTime() - then.getTime()) / 1000);
	if (diffSeconds < 0) return 'just now';
	if (diffSeconds < MINUTE) return 'just now';
	if (diffSeconds < HOUR) {
		const m = Math.floor(diffSeconds / MINUTE);
		return `${m}m ago`;
	}
	if (diffSeconds < DAY) {
		const h = Math.floor(diffSeconds / HOUR);
		return `${h}h ago`;
	}
	if (diffSeconds < WEEK) {
		const d = Math.floor(diffSeconds / DAY);
		return `${d}d ago`;
	}
	if (diffSeconds < MONTH) {
		const w = Math.floor(diffSeconds / WEEK);
		return `${w}w ago`;
	}
	if (diffSeconds < YEAR) {
		const mo = Math.floor(diffSeconds / MONTH);
		return `${mo}mo ago`;
	}
	const y = Math.floor(diffSeconds / YEAR);
	return `${y}y ago`;
}
